import request from '@/utils/request/index';

export type FollowerTagRequestOptions = Parameters<typeof request>[3];

export interface FollowerTagListRequest {
  botId: string;
}

export interface FollowerTagListItem {
  tagId: number;
  tagName: string;
  fanCount?: number;
  sort?: number;
}

export interface FollowerTagListResult {
  allCount?: number;
  noTagCount?: number;
  tags?: FollowerTagListItem[];
}

export interface FollowerTagNameRequest {
  botId: string;
  tagName: string;
}

export interface FollowerTagUpdateRequest extends FollowerTagNameRequest {
  tagId: number;
}

export interface FollowerTagDeleteRequest {
  botId: string;
  tagId: number;
}

export interface FollowerTagSetRequest {
  botId: string;
  /** 粉丝 bot ID，不是粉丝背后真人的 userId */
  fanBotId: string;
  tagIds: number[];
}

export interface FollowerTagBatchAddRequest {
  botId: string;
  /** 粉丝 bot ID 集合 */
  fanBotIds: string[];
  tagIds: number[];
}

export interface FollowerTagBatchAddResult {
  successCount?: number;
  skipCount?: number;
}

export interface FollowerFanListRequest {
  size?: number;
  page?: number;
  isLimit?: boolean;
  lastId?: number;
  botId: string;
  tagId?: number;
  onlyNoTag?: boolean;
  keyword?: string;
}

export interface FollowerFanListItem {
  /** 粉丝 bot ID */
  fanBotId?: string;
  nickname?: string;
  avatar?: string;
  followTime?: string;
  tags?: FollowerTagListItem[];
}

export interface FollowerFanListResult {
  list?: FollowerFanListItem[];
  endPage?: boolean;
}

export const feimaAgentFanTagList = (
  data: FollowerTagListRequest,
  options?: FollowerTagRequestOptions
): Promise<FollowerTagListResult> =>
  request<FollowerTagListResult>('/agent/fan/tag/list', 'POST', data, options);

export const feimaAgentFanTagCreate = (
  data: FollowerTagNameRequest,
  options?: FollowerTagRequestOptions
): Promise<number> =>
  request<number>('/agent/fan/tag/create', 'POST', data, options);

export const feimaAgentFanTagUpdate = (
  data: FollowerTagUpdateRequest,
  options?: FollowerTagRequestOptions
): Promise<null> =>
  request<null>('/agent/fan/tag/update', 'POST', data, options);

export const feimaAgentFanTagDelete = (
  data: FollowerTagDeleteRequest,
  options?: FollowerTagRequestOptions
): Promise<null> =>
  request<null>('/agent/fan/tag/delete', 'POST', data, options);

export const feimaAgentFanTagSet = (
  data: FollowerTagSetRequest,
  options?: FollowerTagRequestOptions
): Promise<null> => request<null>('/agent/fan/tag/set', 'POST', data, options);

export const feimaAgentFanTagBatchAdd = (
  data: FollowerTagBatchAddRequest,
  options?: FollowerTagRequestOptions
): Promise<FollowerTagBatchAddResult> =>
  request<FollowerTagBatchAddResult>(
    '/agent/fan/tag/batchAdd',
    'POST',
    data,
    options
  );

export const feimaAgentFanList = (
  data: FollowerFanListRequest,
  options?: FollowerTagRequestOptions
): Promise<FollowerFanListResult> =>
  request<FollowerFanListResult>('/agent/fan/list', 'POST', data, options);
